import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
// import { IndexGarageApiService } from '../api/index-garage-api.service'
import { ResultInfo, ResultInfoSingle } from 'interserve-commons'
import { IsFromModel } from '@interserve/angular'
interface DataTypeMaster {
    id: string
    name: string
    items: { [key: string]: DataTypeMasterItem }
}
interface DataTypeMasterItem {
    name: string
    jsType: string
    icType: string
    regex: string
    key: string
}
@Injectable({
    providedIn: 'root',
})
export class MasterService {
    constructor(private http: HttpClient) //  private indexGarageApiService: IndexGarageApiService
    {}
    private _dataTypeMaster: DataTypeMaster | undefined
    private menu: any | undefined

    //   private async sendDataTypeMasterApi(): Promise<DataTypeMaster> {
    //     const ret = (await this.indexGarageApiService.getDataTypeMaster()) as DataTypeMaster
    //     if (ret) {
    //       return ret
    //     } else {
    //       // エラーを通知
    //       throw new Error('Masterデータの取得に失敗したか、Masterデータが存在しません')
    //     }
    //   }

    //   async dataTypeMaster() {
    //     if (!this._dataTypeMaster) {
    //       this._dataTypeMaster = await this.sendDataTypeMasterApi()
    //     }
    //     return this._dataTypeMaster
    //   }
    //   async reactiveFormModelDataTypeMaster(): Promise<
    //     {
    //       value: string | boolean | number
    //       label: string
    //     }[]
    //   > {
    //     return await this.convertReactiveFormModel()
    //   }
    //   private async convertReactiveFormModel(): Promise<
    //     {
    //       value: string | boolean | number
    //       label: string
    //     }[]
    //   > {
    //     const dataTypeMaster = await this.dataTypeMaster()
    //     const items = dataTypeMaster.items

    //     const retData = Object.keys(items).map((key) => {
    //       const value = items[key]
    //       return {
    //         value: key,
    //         label: value.name,
    //       }
    //     })
    //     return retData
    //   }
    get Menu(): any | undefined {
        return this.menu
    }
    setMenu(menu: any): void {
        this.menu = menu
    }
}
